import { render, staticRenderFns } from "./PlayerPendingAddDataInputNotImplemented.vue?vue&type=template&id=705c149b&"
import script from "./PlayerPendingAddDataInputNotImplemented.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingAddDataInputNotImplemented.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports